import * as Types from '../../../types/graphql.generated';

import { gql } from '@apollo/client';
import { MediaFragmentDoc } from '../../fragments/generated/media.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MediasQueryVariables = Types.Exact<{
  term: Types.Scalars['String'];
  locale: Types.Scalars['String'];
  limit: Types.Scalars['Int'];
  offset: Types.Scalars['Int'];
}>;


export type MediasQuery = { __typename?: 'Query', medias: { __typename?: 'MediaPaginateResult', totalPages: number, page: number, nextPage?: number | null, prevPage?: number | null, docs: Array<{ __typename?: 'Media', id: string, name: string, altText?: string | null, caption?: string | null, originalUrl: string, type: Types.MediaType, locale: string, mimetype: string, createdAt: string, updatedAt: string, formats: { __typename?: 'Formats', xs: { __typename?: 'MediaFormat', width: number, url: string }, s: { __typename?: 'MediaFormat', width: number, url: string }, m: { __typename?: 'MediaFormat', width: number, url: string }, l: { __typename?: 'MediaFormat', width: number, url: string }, xl: { __typename?: 'MediaFormat', width: number, url: string } } }> } };


export const MediasDocument = gql`
    query Medias($term: String!, $locale: String!, $limit: Int!, $offset: Int!) {
  medias(term: $term, locale: $locale, limit: $limit, offset: $offset) {
    docs {
      ...media
    }
    totalPages
    page
    nextPage
    prevPage
  }
}
    ${MediaFragmentDoc}`;

/**
 * __useMediasQuery__
 *
 * To run a query within a React component, call `useMediasQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediasQuery({
 *   variables: {
 *      term: // value for 'term'
 *      locale: // value for 'locale'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useMediasQuery(baseOptions: Apollo.QueryHookOptions<MediasQuery, MediasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediasQuery, MediasQueryVariables>(MediasDocument, options);
      }
export function useMediasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediasQuery, MediasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediasQuery, MediasQueryVariables>(MediasDocument, options);
        }
export type MediasQueryHookResult = ReturnType<typeof useMediasQuery>;
export type MediasLazyQueryHookResult = ReturnType<typeof useMediasLazyQuery>;
export type MediasQueryResult = Apollo.QueryResult<MediasQuery, MediasQueryVariables>;